// src/components/Stars.js
import React, { useEffect } from "react";

const Stars = () => {
  useEffect(() => {
    const starCount = 100;
    const starContainer = document.getElementById("star-container");

    // Clear existing stars
    starContainer.innerHTML = "";

    // Add twinkling stars
    for (let i = 0; i < starCount; i++) {
      const star = document.createElement("div");
      star.className = "star";
      star.style.top = `${Math.random() * 100}vh`;
      star.style.left = `${Math.random() * 100}vw`;
      star.style.animationDelay = `${Math.random() * 2}s`;
      starContainer.appendChild(star);
    }

    // Add a shooting star every few seconds
    const shootInterval = setInterval(() => {
      const shootingStar = document.createElement("div");
      shootingStar.className = "shooting-star";
      shootingStar.style.top = `${Math.random() * 80}vh`;
      starContainer.appendChild(shootingStar);

      // Remove after animation ends
      setTimeout(() => {
        shootingStar.remove();
      }, 1000);
    }, 3000);

    return () => clearInterval(shootInterval);
  }, []);

  return <div id="star-container" className="starry-bg"></div>;
};

export default Stars;
